import * as React from "react";
import { type UploadStatusMessage, useUploadStatus } from "@/hooks/use-upload-status";
import { FileWithProgress } from "@/views/drive/modals/uploadModal/types";
import { calculateUploadProgress } from "./helpers";
import { TxType } from "@/types/transaction";

interface Props {
  setFiles: React.Dispatch<React.SetStateAction<Array<FileWithProgress>>>;
}

export const UploadModalWebsocket: React.FC<Props> = ({ setFiles }) => {
  const onUploadStatusChange = React.useCallback(
    (event: UploadStatusMessage) => {
      if (event.type === "document" && [TxType.UPLOAD, TxType.CHRONOLOGY].includes(event.tx_type)) {
        setFiles(prevFiles =>
          prevFiles.map(file =>
            event.fse_ids.includes(file.fse_id || "")
              ? {
                  ...file,
                  progress: calculateUploadProgress(event.progress),
                  status: event.progress === 1 ? "completed" : "uploading",
                }
              : file,
          ),
        );
      }
    },
    [setFiles],
  );

  useUploadStatus(onUploadStatusChange);

  return null;
};
